import { render, staticRenderFns } from "./InvitationCheck.vue?vue&type=template&id=3686584a&scoped=true"
import script from "./InvitationCheck.vue?vue&type=script&lang=ts"
export * from "./InvitationCheck.vue?vue&type=script&lang=ts"
import style0 from "./InvitationCheck.vue?vue&type=style&index=0&id=3686584a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3686584a",
  null
  
)

export default component.exports